import type { AppLanguage } from '../i18n/types';

function fieldKeyLower(key: string): string {
  return key.trim().toLowerCase();
}

export function nameFieldDir(language: AppLanguage): 'ltr' | 'rtl' {
  return language === 'he' ? 'rtl' : 'ltr';
}

export function isLtrFormFieldKey(key: string): boolean {
  const lower = fieldKeyLower(key);
  return (
    lower === 'email' ||
    lower.endsWith('_email') ||
    lower === 'password' ||
    lower.endsWith('_password') ||
    lower === 'confirm_password' ||
    lower === 'phone_number' ||
    lower.includes('phone') ||
    lower === 'bank_number' ||
    lower === 'branch_number' ||
    lower === 'account_number' ||
    lower === 'routing_number' ||
    lower === 'business_id' ||
    lower === 'national_id'
  );
}

export function isPlaintextBidiFormFieldKey(key: string): boolean {
  const lower = fieldKeyLower(key);
  if (isLtrFormFieldKey(key)) {
    return false;
  }
  return (
    lower === 'business_name' ||
    lower === 'account_holder_name' ||
    lower.endsWith('_name') ||
    lower.includes('first_name') ||
    lower.includes('last_name')
  );
}

export function formInputClassName(
  baseClass: string,
  key: string,
  inputLtrClass: string,
  inputNameFieldClass: string,
): string {
  if (isLtrFormFieldKey(key)) {
    return `${baseClass} ${inputLtrClass}`.trim();
  }
  if (isPlaintextBidiFormFieldKey(key)) {
    return `${baseClass} ${inputNameFieldClass}`.trim();
  }
  return baseClass;
}

export function formInputDir(key: string, language?: AppLanguage): 'ltr' | 'rtl' | undefined {
  if (isLtrFormFieldKey(key)) {
    return 'ltr';
  }
  if (isPlaintextBidiFormFieldKey(key)) {
    return language ? nameFieldDir(language) : 'ltr';
  }
  return undefined;
}
